<!-- eslint-disable max-lines -->
<template>
    <el-dialog @close="closeLog" v-loading="importLoading" title="导入数据" :visible.sync="addDialog"
        :close-on-click-modal="false" :close-on-press-escape="false" width="600px">
        <el-form :model="filesForm" label-position="right" class="form-dialog" label-width="80px" ref="filesFormDialog">
            <div class="upload-btn">
                <slot name="btnSlot"></slot>
                <lots-button v-if="config.downBtn" size="mini" type="primary" @click="downLoad"
                    :loading="downloadLoading">下载模板</lots-button>
                <lots-upload-button :text="'上传附件'" :bucket="'annto-lcrm'" @beforeUpload="beforeUploadUrl"
                    @callback="(data) => { upLoadFileUrl(data); }"></lots-upload-button>
            </div>
            <el-form-item label="附件名称：" prop="fileName">
                <span>{{ filesForm.fileName || '--' }}</span>
            </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <lots-button size="mini" @click="closeLog">取 消</lots-button>
            <lots-button size="mini" type="primary" :disabled="!filesForm.fileUrl" @click="handleImport"
                :loading="importLoading">导入</lots-button>
        </span>
    </el-dialog>
</template>
<script>
import { ref } from '@vue/composition-api';
import { Message } from 'element-ui';
import lotsButton from '@/components/lots/lotsButton';
import lotsUploadButton from '@/components/lots/oss/UploadBtn';
import _ from 'lodash';
export default {
    name: 'addFileDialog',
    props: {
        config: {
            type: Object,
            default: () => {
                return {};
            }
        }
    },
    components: {
        lotsButton,
        lotsUploadButton
    },
    /* eslint-disable max-lines-per-function */
    setup(props, setupContext) {
        // const tenantCode = store.getters.currentTenant.tenantCode;

        const openImport = () => {
            addDialog.value = true;
        };
        const fileList = ref([]);
        const filesForm = ref({ fileName: '', fileUrl: '' });
        const addDialog = ref(false);
        const downloadLoading = ref(false);
        // 下载模板
        const downLoad = (data) => {
            downloadLoading.value = true;
            props.config.downloadApi({ fileName: props.config.fileName, ...(props.config.downParams || {}) }).then(res => {
                if (+res.code === 0) {
                    Message.success('请稍后到右上角用户文件列表中下载');
                }
            }).finally(() => { downloadLoading.value = false; });
        };
        const closeLog = () => {
            fileList.value = [];
            filesForm.value.fileName = '';
            filesForm.value.fileUrl = '';
            addDialog.value = false;
        };
        // 上传失败
        const handleError = () => {
            Message.error('上传失败');
            setupContext.emit('uploadFailHandle');
        };
        const onChange = (file) => {
            fileList.value = [];
            filesForm.value.fileName = file.name;
            fileList.value.push(file);
        };
        const importLoading = ref(false);
        // 导入
        const handleImport = async () => {
            if (!fileList.value.length) {
                return Message.warning('请先上传附件');
            }
            // 把接口需要的参数带进去
            let res = null;
            importLoading.value = true;
            try {
                let params = _.cloneDeep(filesForm.value);
                const beforeReq = _.get(props.config, 'beforeRequest');
                if (beforeReq && _.isFunction(beforeReq)) {
                    params = beforeReq(params);
                }
                res = await props.config.importApi(params);
                importLoading.value = false;
            } catch (error) {
                importLoading.value = false;
            }
            if (+res.code === 0) {
                Message.success('导入成功');
                setupContext.emit('uploadSuccessHandle', filesForm.value);
                closeLog();
            } else {
                // 报错清空文件
                fileList.value = [];
                filesForm.value.fileName = '';
                filesForm.value.fileUrl = '';
            }
        };
        const beforeUploadUrl = res => {
            filesForm.value.fileName = res.file.name;
        };
        const upLoadFileUrl = (res) => {
            if (res && +res.code === 0) {
                filesForm.value.fileUrl = res.data.downUrl;
                fileList.value = [{
                    fileUrl: res.data.downUrl,
                    fileName: res.data.name
                }];
            }
        };
        return {
            downLoad,
            fileList,
            filesForm,
            addDialog,
            openImport,
            downloadLoading,
            closeLog,
            handleError,
            onChange,
            importLoading,
            handleImport,
            beforeUploadUrl,
            upLoadFileUrl
        };
    }
};
</script>
<style lang="less" scope>
.upload-btn {
    display: flex;
    // padding: 0px 0px 15px 80px;
    margin: 0 0 0 8px;

    .upload-demo {
        margin-left: 10px;
    }
}
</style>
